<!-- The hack with mode is required because for some reason ionic cannot bind mode property dynamically -->
<!-- For details please reference issue: https://github.com/ionic-team/ionic-framework/issues/29429 -->
<ion-radio-group
  *ngIf="isOvalStyle"
  mode="ios"
  (ionChange)="onOptionSwitch($event)"
  [value]="selectedValue()"
>
  <ng-container [ngTemplateOutlet]="radioItems"></ng-container>
</ion-radio-group>

<ion-radio-group
  *ngIf="!isOvalStyle"
  mode="md"
  (ionChange)="onOptionSwitch($event)"
  [value]="selectedValue()"
>
  <ng-container [ngTemplateOutlet]="radioItems"></ng-container>
</ion-radio-group>

<ng-template #radioItems>
  <ion-item
    *ngFor="let option of options; let index = index"
    lines="none"
    class="mb-radio"
    [ngClass]="size"
    [disabled]="disabled"
  >
    <ion-radio
      labelPlacement="end"
      alignment="center"
      [slot]="isOvalStyle ? '' : 'start'"
      [value]="option[this.valueField]"
      [attr.aria-label]="option.ariaLabel || option.name"
      [attr.data-testid]="option.dataTestId || 'radio-group-option-' + index"
      [innerHTML]="option.name"
    />
  </ion-item>
</ng-template>
